namespace SolovisGateway.Admin.Organizations {

    export interface OrgAddDomainToLiveConnectionDialogOptions extends SupportContactOptions {
        domain: string;
        onAdd?: () => void;
        onCancel?: () => void;
    }

    export class OrgAddDomainToLiveConnectionDialog {

        private _options: OrgAddDomainToLiveConnectionDialogOptions;

        private _dialog: any;
        private _confirmContainer: JQuery;
        private _loaderContainer: JQuery;
        private _alreadyAddedBanner: JQuery;
        private _errorBanner: JQuery;

        constructor(options: OrgAddDomainToLiveConnectionDialogOptions) {
            this._options = options;
        }

        public show() {
            var body = $("<div>").css({ "padding": "0 15px" });

            var confirmContainer = $("<div>");
            body.append(confirmContainer);
            this._confirmContainer = confirmContainer;

            var alreadyAddedBanner = $("<div>").css({
                "background-color": "#fcf8e3",
                "border": "1px solid #faebcc",
                "color": "#8a6d3b",
                "padding": "12px 15px",
                "border-radius": "4px",
                "margin-bottom": "15px",
                "display": "none"
            });
            confirmContainer.append(alreadyAddedBanner);
            this._alreadyAddedBanner = alreadyAddedBanner;

            var errorBanner = $("<div>").css({
                "background-color": "#f2dede",
                "border": "1px solid #ebccd1",
                "color": "#a94442",
                "padding": "12px 15px",
                "border-radius": "4px",
                "margin-bottom": "15px",
                "display": "none"
            });
            confirmContainer.append(errorBanner);
            this._errorBanner = errorBanner;

            confirmContainer.append($("<p>").append(
                $("<strong>").text(this._options.domain),
                $("<span>").text(" will start federating to your identity provider as soon as it is added.")
            ));

            var impactBox = $("<div>").css({
                "border": "1px solid #ddd",
                "padding": "12px 15px",
                "background-color": "#f9f9f9",
                "margin-bottom": "15px"
            });
            impactBox.append(
                $("<span>").text("All users on "),
                $("<strong>").text(this._options.domain),
                $("<span>").text(" will start signing in through your identity provider instead of a username and password.")
            );
            confirmContainer.append(impactBox);

            confirmContainer.append($("<p>").text(
                "Their access, roles, and environments do not change. Only the way they sign in changes."
            ));

            var warningBanner = $("<div>").css({
                "background-color": "#fcf8e3",
                "border": "1px solid #faebcc",
                "color": "#8a6d3b",
                "padding": "12px 15px",
                "border-radius": "4px"
            });
            warningBanner.append(
                $("<span>").text("Any user on "),
                $("<span>").text(this._options.domain),
                $("<span>").text(" who is not assigned to the SSO application in your identity provider will not be able to sign in until they are added there.")
            );
            confirmContainer.append(warningBanner);

            var loaderContainer = $("<div>")
                .css({ "position": "relative", "height": "150px", "display": "none" });
            Solovis.UI.StockAnimations.createSpinningCircles({
                diameter: "60px",
                top: "50%",
                left: "50%",
                showShadow: true
            }).appendTo(loaderContainer);
            body.append(loaderContainer);
            this._loaderContainer = loaderContainer;

            this._dialog = new (Solovis as any).UI.Dialog({
                container: body,
                title: "Add " + this._options.domain + " to this connection?",
                modal: true,
                autoOpen: true,
                center: true,
                destroyOnClose: true,
                actions: ["Close"],
                width: 600,
                buttons: this._buildDefaultButtons()
            });
        }

        public close() {
            this._dialog.close();
        }

        public resetToConfirm() {
            this._loaderContainer.hide();
            this._alreadyAddedBanner.hide();
            this._errorBanner.hide();
            this._confirmContainer.show();
            this._dialog.updateButtons(this._buildDefaultButtons());
        }

        public showAlreadyAdded() {
            this._loaderContainer.hide();
            this._errorBanner.hide();
            this._alreadyAddedBanner.text(this._options.domain + " is already on this connection.").show();
            this._confirmContainer.show();
            this._dialog.updateButtons(this._buildDefaultButtons());
        }

        // Accepts either a plain string or pre-built nodes (e.g. from
        // SsoConnectionStatusUi.buildSupportContactNodes) so error messages that need to render an
        // actual support-contact link, not just its text, can do so.
        public showError(content: string | Array<JQuery>) {
            this._loaderContainer.hide();
            this._alreadyAddedBanner.hide();
            this._errorBanner.empty();
            if (typeof content === "string") {
                this._errorBanner.text(content);
            }
            else {
                content.forEach((node) => this._errorBanner.append(node));
            }
            this._errorBanner.show();
            this._confirmContainer.show();
            this._dialog.updateButtons(this._buildDefaultButtons());
        }

        private _buildDefaultButtons() {
            var self = this;
            return [
                {
                    label: "Add Domain",
                    click: function () {
                        self._attemptAdd();
                    }
                },
                {
                    label: "Cancel",
                    click: function () {
                        self._dialog.close();
                        if (self._options.onCancel) {
                            self._options.onCancel();
                        }
                    }
                }
            ];
        }

        private _attemptAdd() {
            this._confirmContainer.hide();
            this._alreadyAddedBanner.hide();
            this._errorBanner.hide();
            this._loaderContainer.show();
            this._dialog.updateButtons([]);

            if (this._options.onAdd) {
                this._options.onAdd();
            }
        }
    }
}
